import React from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";

// components
import Layout from "./Layout";
import MerchantRoutes from "../systems/merchant/routes/MerchantRoutes";
import ProfitRoutes from "../systems/profit/routes/ProfitRoutes";

// pages
import Error from "../pages/error";
import Login from "../pages/login";

// context
import { useUserState } from "../context/UserContext";

export default function App() {
  // global
  const { isAuthenticated } = useUserState();

  return (
    <HashRouter>
      <Switch>
        <Route path="/profit" component={ProfitRoutes} />
        <Route
          path="/app"
          render={(props) => (
            <Redirect
              to={{
                pathname: getLegacyRedirectPath(props.location.pathname, "/app", "/bak"),
                search: props.location.search,
              }}
            />
          )}
        />
        <Route
          path="/merchant"
          render={(props) => (
            <Redirect
              to={{
                pathname: getLegacyRedirectPath(props.location.pathname, "/merchant", ""),
                search: props.location.search,
              }}
            />
          )}
        />
        <PublicRoute exact path="/bak/login" component={Login} />
        <PrivateRoute path="/bak" component={Layout} />
        <Route path="/" component={MerchantRoutes} />
        <Route component={Error} />
      </Switch>
    </HashRouter>
  );

  // #######################################################################

  function PrivateRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={(props) =>
          isAuthenticated ? (
            React.createElement(component, props)
          ) : (
            <Redirect
              to={{
                pathname: "/bak/login",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        }
      />
    );
  }

  function PublicRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={(props) =>
          isAuthenticated ? (
            <Redirect
              to={{
                pathname: "/bak/dashboard",
              }}
            />
          ) : (
            React.createElement(component, props)
          )
        }
      />
    );
  }
}

function getLegacyRedirectPath(pathname, legacyPrefix, nextPrefix) {
  const suffix = pathname === legacyPrefix ? "" : pathname.slice(legacyPrefix.length);
  const normalizedNextPrefix = nextPrefix === "/" ? "" : nextPrefix;

  return normalizedNextPrefix + suffix || "/";
}
